module.exports = __webpack_public_path__ + "img/docusign-logo.6dbfcd7c.jpg";